import { DefaultRequest } from 'scripts/api';

class StopRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "Stop";
    const model = App.Models.Stop;
    const collectionClass = App.Collections.Stops;
    const tabSelector = "Route";

    super(entityName, model, collectionClass, tabSelector);

    this.stopTypeLookupNamespace = "StopStopTypeLookup";
    this.locationLookupNamespace = "StopLocationLookup";
  }

  afterCreateForm = function(entity, formData, crudStage) {
    const routeScreen = document.getElementById("Route");
    const btnsExit = document.querySelectorAll("#Route #Stop_btn_exit");
    const labelBtn =  Monet.I18n.getResourcesByKey("stop.button.backToRoute");
    if(btnsExit) {
      btnsExit.forEach(btn => btn.value = labelBtn);
    }

    if (routeScreen) {
      routeScreen.style.display = "block";
    }

    const routeId = this.editModelId;
    let view = null;

    const form = App.Forms.Stop.form;

    if (crudStage === "new") {
      form.getModel().set({ route: { id: routeId } });
      view = App.Views.Stop;
      view.resetPlacementField();
      view.populatePlacementFieldAndListStops(routeId);
    } else if (crudStage === "edit") {
      form.route = { id: routeId };
    }

    this.updateBodyRequestLocation();
    this.getStatusRouteAndDisableDeleteButton(routeId);

  };

  updateBodyRequestLocation = function() {
    var defaultCriteriaForFields = {
      criteriaChain: [
        {
          and: [{ attr: "enabled", eq: true }]
        }
      ]
    };

    App.Forms.Stop.form.fields.location.setRequestBody(
      defaultCriteriaForFields
    );
  };

  afterPopulateForm = function() {
    Monet.Session = Monet.Session || {};
    Monet.Session.TreeviewRoute = Monet.Session.TreeviewRoute || {};

    var form = App.Forms.Stop.form,
      model = form.getModel(),
      stopKeyField = form.fields.key,
      routeId = model.get("route").id,
      stopId = model.get("id"),
      routeNameSp = Monet.Session.TreeviewRoute[routeId],
      routerStatus = routeNameSp.route.attributes.status,
      disableFirstStopCheckbox = function() {
        form.fields.firstStop.input.disabled = true;
      };

    if (routeNameSp) {
      if (routerStatus !== "NOT_STARTED") {
        disableFirstStopCheckbox();
      }

      const stopCollection = routeNameSp.stops;

      if (stopCollection) {
        const stop = stopCollection.getById(stopId);

        if (stop && stop.get("location")) {
          stopKeyField.input.readOnly = true;
          stopKeyField.input.disabled = false;
          stopKeyField.rootEl.className += " MonetUIFieldsReadOnlyClickable";
          stopKeyField.input.addEventListener("click", function() {
            window.location.href = "#/Location/edit/" + stop.get("location").id;
          });
        }
      }
    }

    if (model.get("cancelCode")) {
      this.disableButtonsToRouteFinished();
    } else if (model.get("actualComplete") || model.get("actualArrival")) {
      this.disableButtonsToRouteFinished();
    }
  };

  newStop = () => {
    this.cleanTreeViewMarks();
    const routeId = App.Forms.Stop.form.getModel().get('route').id;
    const url = `#/Route/${routeId}/Stop/new`;
    window.location.href = url;
  };

  saveStopAndClose = () => {
    this.saveStop("close");
  };

  saveStopAndAddNew = () => {
    this.saveStop("new");
  };

  updateStopAndClose = () => {
    this.updateStop("close");
  };

  updateStopAndNew = () => {
    this.updateStop("new");
  };

  validate = () => {
    var form = App.Forms.Stop.form;
    var allow_submit = form.validate();
    var stopTypeLookup = App.Forms[this.stopTypeLookupNamespace].lookupElement;

    if (stopTypeLookup.getFullValue().id) {
      var locationRequired = stopTypeLookup.getFullValue().model
          .locationRequired,
        locationLookup = App.Forms[this.locationLookupNamespace].lookupElement;
      if (locationRequired) {
        locationLookup.mandatory = true;
        var validateLocation = locationLookup.validate();
        allow_submit.errorMessages.push.apply(
          allow_submit.errorMessages,
          validateLocation
        );
        allow_submit.status = allow_submit.errorMessages.length === 0;
        locationLookup.mandatory = false;
      }
    }
    return allow_submit;
  };

  saveStop = returnTo => {
    const that = this;
    const form = App.Forms[this.entityName].form;
    const routeId = form.getModel().get("route").id;
    const callback = async (model) => {
      let error = null,
        view = null,
        divError = null;
      try {
        const route = new App.Routers.Route();
        if (returnTo === "close") {
          route.goToEditRoute(routeId);
        } else {
          view = App.Views.Stop;
          divError = document.querySelector(".monetInlineAlerContainer");
          view.clearFieldsToForm("#Route .control-group input");
          divError.innerHTML = "";
          view.resetPlacementField();
          view.populatePlacementFieldAndListStops(routeId);
        }
        route.createTreeview(App.Forms.Route.form.getModel());
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "Error on callback save stop",
          e        );
        error.console();
      }
    };

    const hidePreviousErrors = function() {
      const selector = `#${that.getTabIdSelector()} .monetInlineAlerContainer`;
      const previousErrors = document.querySelector(selector);

      if (previousErrors.innerHTML) {
        previousErrors.innerHTML = "";
      }
    };

    const allow_submit = this.validate();

    if (allow_submit.status) {
      const dataModel = form.getValues();
      form.triggerLoadingBtns();

      const obj = { placement: "", stop: {} };

      for (let key in dataModel) {
        if (key === "placement") {
          obj.placement = dataModel[key];
        } else if (key !== "route" && key !== "relatedStop") {
          obj.stop[key] = dataModel[key];
        }
      }

      if (obj.placement === "AFTER_STOP" || obj.placement === "BEFORE_STOP") {
        obj.relatedStop = { id: dataModel.relatedStop };
      }

      hidePreviousErrors();

      const request = new DefaultRequest({
        url: "Route/" + routeId + "/AddStop",
        method: "post",
        data: obj,
        success: function(model) {
          form.triggerLoadingBtns();
          callback(model);
        },
        error: function(data) {
          const monetMessage = new Monet.Form.Messages.InlineMessage();
          form.triggerLoadingBtns();

          monetMessage.setScope("#Route");
          monetMessage.setInfoType("error");
          monetMessage.setMessage(JSON.parse(data.responseText));
          monetMessage.triggerMessage();
        }
      });

      request.send();
    } else {
      this.createAndUpdateErrorHandler(allow_submit, false);
    }
  };

  updateStop = returnTo => {
    var routeId = App.Forms.Stop.form.getModel().get("route").id;

    var callback = async () => {
      var error = null;
      try {
        if (returnTo === "close") {
          var route = new App.Routers.Route();
          route.goToEditRoute(routeId);
        } else {
          App.Forms.Stop.form.getModel().set({ route: { id: routeId}});
          this.newStop();
        }

        this.cleanTreeViewMarks();
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "Error on callback save stop",
          e
        );
        error.console();
      }
    };

    this.update(callback);
  };

  remove = () => {
    const form = App.Forms[this.entityName].form;
    const model = form.getModel();
    const routeId = model.attributes.route.id;

    const callbackError = message => {
      const monetMessage = new Monet.Form.Messages.InlineMessage();
      monetMessage.setScope(".MonetUIForm.Stop");
      monetMessage.setInfoType("error");
      monetMessage.setMessage(message);
      monetMessage.triggerMessage();
    };

    if (!model.get("actualDeparture")) {
      if (!model.get("cancelCode")) {
          form.triggerLoadingBtns();
          const callback = async (model, routeId) => {
            try {
              const route = new App.Routers.Route();
              route.createTreeview(App.Forms.Route.form.getModel());
              window.location.href = "#/Route/" + routeId + "/Stop/new";
            } catch (e) {
              const error = new Monet.Exception.ReturnError(this, "Error on callback remove stop.");
              error.console();
            }
          };

        this.collection.destroy(model, {
          success: () => {
            form.triggerLoadingBtns();
            callback(model, routeId);
          },
          error: (response) => {
            form.triggerLoadingBtns();
            const responseText = response.responseText && JSON.parse(response.responseText);
            const errorMessages = responseText && responseText.errorMessages;
            if (errorMessages) {
              callbackError(Monet.Form.Messages.getErrorMessageToBeDisplayed(errorMessages));
            }
          }
        });
      } else {
        callbackError();
      }
    } else {
      callbackError();
    }
  };

  exit = () => {
    const routeId = App.Forms.Stop.form.getModel().get("route").id;
    if(routeId) {
      this.goToEditRouteInTreeview(routeId);
    }
  }

  goToEditRouteInTreeview = (routeId) => {
    const isInFormRoute = document.querySelector("#Route form.MonetUIForm.Route");
    if (!isInFormRoute) {
      new Greenmile.Components.AlertModal("greenmile.message.exitOnScreen",
        null,
        () => { window.location.href = `#/Route/edit/${routeId}` }
      ).show();
    }

    this.cleanTreeViewMarks();
  };

  checkLocalCollection = async (id, callback) => {
    const routeId = this.editModelParentId;
    const stopId = this.editModelId;

    Monet.Session.TreeviewRoute = Monet.Session.TreeviewRoute || {};
    Monet.Session.TreeviewRoute[routeId] =
      Monet.Session.TreeviewRoute[routeId] || {};

    var stopCollection = Monet.Session.TreeviewRoute[routeId].stops;
    var routeModel = Monet.Session.TreeviewRoute[routeId].route;

    if (routeId && stopId) {
      if (stopCollection) {
        var model = stopCollection.getById(stopId);
        model.set({ route: routeModel.attributes });
        callback(model);
      } else {
        var routeRouter = new App.Routers.Route();
        Monet.Session.TreeviewRoute[routeId] = await routeRouter.getValuesToNamespace(
          routeId
        );
        this.checkLocalCollection(stopId, callback);
      }
    }
  };

  formatNodeStopToTreeview = (routeId, model) => {
    var obj,
      data,
      key = model.attributes.location
        ? model.attributes.location.key
        : model.attributes.key,
      description = model.attributes.location
        ? model.attributes.location.description
        : "",
      stopId = model.attributes.id,
      label = key + (description ? " - " + description : ""),
      strAction =
        "new App.Routers.Route().openEditStop(" +
        routeId +
        "," +
        stopId +
        ",event);";

    if (model.attributes.firstStop) {
      data = {
        title: label,
        icon: "first-stop"
      };
    } else {
      data = label;
    }

    obj = {
      data: data,
      attr: {
        id: "stop_" + stopId,
        action: strAction,
        class: "treeviewStopItem"
      }
    };

    return obj;
  };

  cleanTreeViewMarks = () => {
    const routeView = App.Views.Route;

    routeView.removeNodesClickedInTreeView();
  };

  disableButtonsToRouteFinished = () => {
    document
      .querySelectorAll("#Route input[type='button']")
      .forEach(function(item) {
        if (item.name !== "btn_exit") {
          item.setAttribute("disabled", "disabled");
        }
      });
  };

  getStatusRouteAndDisableDeleteButton = routeId => {
    const ajax = new Monet.Ajax();
    ajax.url =
      'Route/restrictions?criteria={"filters":["id", "status"], "firstResult":0,"maxResults":1}';
    ajax.responseType = "json";
    ajax.method = "post";
    ajax.data = {
      criteriaChain: [
        {
          and: [{ attr: "id", eq: routeId }]
        }
      ]
    };
    ajax.success = function(data) {
      const route = data[0] || {};
      if (route.hasOwnProperty("status") && route.status !== "NOT_STARTED") {
        document
          .querySelectorAll("#Route #Stop_btn_delete")
          .forEach(function(btn) {
            btn.setAttribute("disabled", "disabled");
          });
      }
    };
    ajax.send();
  };
}

App.Routers.Stop = StopRouter;
